// extracted by mini-css-extract-plugin
export default {"info":"General_info__GyOX8","title":"General_title__REr3w","actions":"General_actions__KpJJv","cancelBtn":"General_cancelBtn__38fIP"};